<template>
    <div class="about">
        <v-header />
        <v-sidebar />
        <div class="content-box" :class="{ 'content-collapse': collapse }">
            <v-tags></v-tags>
            <div class="content">
                <el-scrollbar
                    wrapClass="scrollbar-wrap"
                    :style="{height: scrollHeight}"
                    ref="scrollbarContainer">
                    <router-view v-slot="{ Component }">
                        <transition name="move" mode="out-in">
                            <keep-alive :include="tagsList">
                                <component :is="Component" />
                            </keep-alive>
                        </transition>
                    </router-view>
                </el-scrollbar>
                <!-- <el-backtop target=".content"></el-backtop> -->
            </div>
        </div>
    </div>
</template>
<script>
import vHeader from "../components/Header";
import vSidebar from "../components/Sidebar";
import vTags from "../components/Tags.vue";
export default {
    components: {
        vHeader,
        vSidebar,
        vTags
    },
    data () {
        return {
            scrollHeight:'0px'
        }
    },
    mounted(){
        let height = $(".content-box .content").height();
        this.scrollHeight = (height) + 'px';
    },
    computed: {
        tagsList() {
            return this.$store.state.tagsList.map(item => item.name);
        },
        collapse() {
            return this.$store.state.collapse;
        }
    }
};

    
</script>

<style lang='less'>
 
    .el-scrollbar{
      height: 90%;
      .scrollbar-wrap{
        overflow-x: hidden!important;
      }
      .el-scrollbar__bar{
        overflow-x: hidden!important;
      }
    }
    .el-scrollbar__wrap{
      overflow-x: hidden!important;
    }
</style>
